import React from 'react'
import { Switch } from 'react-router-dom'
import TemplateWrapper from '../template-wrapper'
import routes from '../../routes'
import ServerError from '../../components/server-error'
import Route from '../../components/boundary-route'
import ErrorPage from '../../pages/error'

const Application = context => (
  <TemplateWrapper>
    <ServerError
      renderError={error => <ErrorPage status={context.status} error={error} />}
    >
      <Switch>
        {routes.map(route => (
          <Route
            renderError={({ error }) => (
              <ErrorPage status={context.status} error={error} />
            )}
            key={route.path || 'error'}
            {...route}
          />
        ))}
      </Switch>
    </ServerError>
  </TemplateWrapper>
)

export default Application
